import React from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'
import moment from 'moment'
import { isMobile } from 'react-device-detect'
import { Col, DatePicker, Tooltip } from 'core/components/ui'
import { tradeInShape } from '../../../shapes'
import { IconStyled, InputWrapper, InterTitle } from '../../styled'
import { getFormatDate } from '../../../../core/utils/cultures/unit'

const FormItem = ({ vehicle, setTradeIn, tradeIn }) => {
  const intl = useIntl()
  const { dateOfRegistration } = vehicle

  const handleChange = value => {
    const extendedVehicle = { ...vehicle, dateOfRegistration: value }
    setTradeIn({
      ...tradeIn,
      vehicle: extendedVehicle
    })
  }

  return (
    <Col xs={{ span: 24 }} sm={{ span: 24 }} lg={{ span: 12 }}>
      <InterTitle>
        <FormattedMessage id="tradeIn-historical-subtitle-4" />
        <Tooltip
          classNames={{ root: 'globaldealer-tooltip-information' }}
          title={intl.formatMessage({ id: 'tradeIn-historical-question-4-tooltip' })}
        >
          <IconStyled type="info-circle" style={{ fontSize: '18px' }} />
        </Tooltip>
      </InterTitle>
      <InputWrapper>
        <Col xs={{ span: 16 }} lg={{ span: 4 }}>
          <DatePicker
            format={getFormatDate()}
            value={dateOfRegistration && moment(dateOfRegistration)}
            onChange={handleChange}
            style={{ width: isMobile ? '100%' : '200px', minWidth: '200px' }}
            disabledDate={current => current > moment().endOf('day')}
          />
        </Col>
      </InputWrapper>
    </Col>
  )
}

FormItem.propTypes = {
  vehicle: PropTypes.shape().isRequired,
  setTradeIn: PropTypes.func.isRequired,
  tradeIn: tradeInShape.isRequired
}

export default { FormItem }
